module.exports = __webpack_public_path__ + "static/file/2018_Parent_Resource_Guide.136b558.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/2018_Parent_Resource_Guide.pdf
// module id = ioDr
// module chunks = 18